<template>
  <div class="container">
    <div v-if="medicines_print.length == 0" class="text-center">
      Nenhum medicamento selecionado!
    </div>
    <div v-if="medicines_print.length > 0">
      <div class="row">
        <div class="col-md-12 v-clean text-center" v-if="doctors.length == 0">
          0 Usuários do tipo médico!
          <br />
          Você pode estar definindo médico, em Usuários -> editar -> marque o
          campo <code>MÉDICO?</code>, assim será litado aqui!
        </div>
        <div
          class="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-12 p-0"
          v-if="doctors.length > 0"
        >
          <label>SELECIONE O MÉDICO:</label>
          <v-select
            @change="handleItemValueDoctor"
            v-model="doctor"
            :items="doctors"
            placeholder="SELECIONE..."
            dense
            outlined
            :item-value="(e) => (doc = e)"
            :item-text="(value) => String(value.name).toUpperCase()"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <ErrorsMessages :errors="errors" />
          <h6 class="text-five mb-0 worksansr">
            RECEITA: {{ medicines_print[0].recipe_name }}
          </h6>
        </div>
      </div>
    </div>
    <div
      class="border-bottom"
      v-for="(medicine, key) in medicines_print"
      :key="key"
    >
      <div class="row">
        <div class="col-md-6">
          <h6 class="color-black">{{ medicine.name }}</h6>
          <h6 class="legends worksansr">
            {{ medicine.active_ingredient_name }}
          </h6>
          <h6 class="legends worksansr" v-if="medicine.instruction">
            {{ medicine.instruction }}
          </h6>
        </div>
        <div class="col-md-6">
          <div>
            <h6 v-if="medicine.frequency == 'EVENTUAL'" class="mb-0 worksansr">
              EVENTUAL
            </h6>
            <div class="mb-0" v-if="medicine.frequency == 'SEMANAL'">
              Dias da semana:
              {{ medicine.dom && "DOM" }}
              {{ medicine.seg && "SEG" }}
              {{ medicine.ter && "TER" }}
              {{ medicine.qua && "QUA" }}
              {{ medicine.qui && "QUI" }}
              {{ medicine.sex && "SEX" }}
              {{ medicine.sab && "SAB" }}
            </div>
            <div>
              <span
                v-if="
                  medicine.medicine_amount_of_times_name &&
                  medicine.medicine_amount_of_times_type != 'SHIFTS'
                "
              >
                {{ medicine.medicine_amount_of_times_name }}:
              </span>
              <b
                v-if="
                  medicine.medicine_amount_of_times_type == 'DAY' ||
                  medicine.frequency == 'EVENTUAL'
                "
              >
                {{
                  `${
                    medicine.drops
                      ? `${medicine.drops} GOTA(S)`
                      : medicine.ui
                      ? `${medicine.ui} UI`
                      : medicine.quantity
                  } ${
                    medicine.drops
                      ? ""
                      : medicine.ui
                      ? ""
                      : `- ${medicine.unit_of_measurement_abbreviation} (S)`
                  }`
                }}
              </b>
            </div>
            <div v-if="medicine.medicine_amount_of_times_type == 'SHIFTS'">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>TURNO</th>
                      <th>QUANTIDADE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="medicine.dawn && medicine.dawn_quantity">
                      <td>MADRUGADA</td>
                      <td>
                        {{
                          medicine.drops_dawn_quantity
                            ? `${medicine.drops_dawn_quantity} GOTA(S)`
                            : medicine.ui_dawn_quantity
                            ? `${medicine.ui_dawn_quantity} UI`
                            : medicine.dawn_quantity
                        }}
                        {{
                          medicine.drops_dawn_quantity
                            ? ""
                            : medicine.ui_dawn_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.morning && medicine.morning_quantity">
                      <td>MANHÃ</td>
                      <td>
                        {{
                          medicine.drops_morning_quantity
                            ? `${medicine.drops_morning_quantity} GOTA(S)`
                            : medicine.ui_morning_quantity
                            ? `${medicine.ui_morning_quantity} UI`
                            : medicine.morning_quantity
                        }}
                        {{
                          medicine.drops_morning_quantity
                            ? ""
                            : medicine.ui_morning_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr
                      v-if="medicine.afternoon && medicine.afternoon_quantity"
                    >
                      <td>TARDE</td>
                      <td>
                        {{
                          medicine.drops_afternoon_quantity
                            ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                            : medicine.ui_afternoon_quantity
                            ? `${medicine.ui_afternoon_quantity} UI`
                            : medicine.afternoon_quantity
                        }}
                        {{
                          medicine.drops_afternoon_quantity
                            ? ""
                            : medicine.ui_afternoon_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.night && medicine.night_quantity">
                      <td>NOITE</td>
                      <td>
                        {{
                          medicine.drops_night_quantity
                            ? `${medicine.drops_night_quantity} GOTA(S)`
                            : medicine.ui_night_quantity
                            ? `${medicine.ui_night_quantity} UI`
                            : medicine.night_quantity
                        }}
                        {{
                          medicine.drops_night_quantity
                            ? ""
                            : medicine.ui_night_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.shift_5 && medicine.shift_5_quantity">
                      <td>5º</td>
                      <td>
                        {{
                          medicine.drops_shift_5_quantity
                            ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                            : medicine.ui_shift_5_quantity
                            ? `${medicine.ui_shift_5_quantity} UI`
                            : medicine.shift_5_quantity
                        }}
                        {{
                          medicine.drops_shift_5_quantity
                            ? ""
                            : medicine.ui_shift_5_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.shift_6 && medicine.shift_6_quantity">
                      <td>6º</td>
                      <td>
                        {{
                          medicine.drops_shift_6_quantity
                            ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                            : medicine.ui_shift_6_quantity
                            ? `${medicine.ui_shift_6_quantity} UI`
                            : medicine.shift_6_quantity
                        }}
                        {{
                          medicine.drops_shift_6_quantity
                            ? ""
                            : medicine.ui_shift_6_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.shift_7 && medicine.shift_7_quantity">
                      <td>7º</td>
                      <td>
                        {{
                          medicine.drops_shift_7_quantity
                            ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                            : medicine.ui_shift_7_quantity
                            ? `${medicine.ui_shift_7_quantity} UI`
                            : medicine.shift_7_quantity
                        }}
                        {{
                          medicine.drops_shift_7_quantity
                            ? ""
                            : medicine.ui_shift_7_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                    <tr v-if="medicine.shift_8 && medicine.shift_8_quantity">
                      <td>8º</td>
                      <td>
                        {{
                          medicine.drops_shift_8_quantity
                            ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                            : medicine.ui_shift_8_quantity
                            ? `${medicine.ui_shift_8_quantity} UI`
                            : medicine.shift_8_quantity
                        }}
                        {{
                          medicine.drops_shift_8_quantity
                            ? ""
                            : medicine.ui_shift_8_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation} (S)`
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
          <h6 class="worksansr">
            VIA DE ADMINISTRAÇÃO -
            {{ medicine.route_of_administration_name }}
          </h6>
          <p
            v-if="medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'"
            class="btn-pendent inline-display"
          >
            CONTROLE ESPECIAL
          </p>
        </div>
      </div>
    </div>
    <div v-if="medicines_print.length > 0" class="text-right mt-2">
      <v-btn @click="handlePrintNewWindow" class="ml-2 btn-print"
        ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

export default {
  name: "Recipe",
  components: {
    ErrorsMessages,
  },
  props: {
    user: Object,
    client: Object,
    resident: Object,
    doctors: Array,
    group_prescription_medicine: Object,
    medicines_print: Array,
  },
  data() {
    return {
      print: false,
      doctor: false,
      doc: false,
      errors: [],
    };
  },
  methods: {
    handlePrint() {
      if (!this.doctor.name) {
        this.errors = [{ id: 1, message: "Informe o médico" }];
        return;
      }

      this.errors = [];

      this.print = false;
      setTimeout(() => (this.print = true), 200);

      // let route = this.$router.resolve({
      //   name: "print-recipe",
      //   params: {
      //     doctor_id: this.doctor.id,
      //     group_prescription_medicine_id: this.group_prescription_medicine.id,
      //     prescription_medicine_id: this.medicines_print
      //       .map(({ id }) => id)
      //       .join(","),
      //   },
      // });

      // window.open(route.href, "_blank");
    },
    handlePrintNewWindow() {
      if (!this.doctor.name) {
        this.errors = [{ id: 1, message: "Informe o médico" }];
        return;
      }

      this.errors = [];
      this.print = false;

      let route = this.$router.resolve({
        name: "print-recipe",
        params: {
          doctor_id: this.doctor.id,
          group_prescription_medicine_id: this.group_prescription_medicine.id,
          prescription_medicine_id: this.medicines_print
            .map(({ id }) => id)
            .join(","),
        },
      });

      window.open(route.href, "_blank");
    },
    handleItemValueDoctor() {
      this.doctor = this.doc;
    },
  },
};
</script>
